module.exports = __webpack_public_path__ + "static/media/Nota Parrillada para celebrar en familia con Grill Mates.a3f93436.jpg";